import { ResourceAction } from '../../../authentication/authorization-service';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { OmnibarEntry } from '../omnibar-interfaces';

export const catalogCorrectionsToggle = 'EnableOmnibarCatalogCorrections';

const citizenRead: ResourceAction[] = [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Citizen }];

// "Opret sag" and "Opret persongruppemarkering" share an id, so corrections are keyed by id and label.
function key(id: string, label: string) {
  return `${id}|${label}`;
}

const removedEntries = new Set([key('a8fa99cd-098e-4042-ae65-9778aa18ee6f', 'Opret journalnotat')]);

const corrections = new Map<string, Partial<OmnibarEntry>>([
  [
    key('24ca709c-5914-42cb-a5bb-ef8a67734f3a', 'Opret sag'),
    { group: 'Borgerhandling', resourceActions: [{ resourceOperation: ResourceOperations.Case.Create, resourceType: ResourceTypes.Case }] },
  ],
  [key('24ca709c-5914-42cb-a5bb-ef8a67734f3a', 'Opret persongruppemarkering'), { id: '9c1e7b42-3f6a-4d8e-b5a1-2e7c4f9d8a63', group: 'Borgerhandling' }],
  [key('24ca7dse-5914-42cb-a5bb-ef8a67734f3a', 'Opret underretning til A-kasse'), { group: 'Borgerhandling' }],
  [key('b8c00dd9-0b8e-43fe-8460-1065ee5f356c', 'Plan & Aktiviteter'), { resourceActions: citizenRead }],
  [key('a907d734-1286-419a-8cee-9ae86caad544', 'Rådighed & Fritagelser'), { resourceActions: citizenRead }],
  [key('a0ced348-c972-415d-832b-bbd4cbde96ec', 'Sager'), { resourceActions: citizenRead }],
  [key('58fbb8e6-9110-433c-aa9e-c7cf45777751', 'Samtaler'), { resourceActions: citizenRead }],
  [key('1347277f-39ff-445b-8758-80070c95eada', 'Aktindsigt'), { resourceActions: citizenRead }],
  [key('c62ce676-e8ae-4235-a764-13308fd982c2', 'Kandidatformidlinger'), { resourceActions: citizenRead }],
  [
    key('d6fbb580-251d-402c-82b2-dccde89aa595', 'Opret rekrutteringsanmodning'),
    { resourceActions: [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.CompanyRecruitment }] },
  ],
  [key('1c51d088-2316-45b2-a702-176976af9e79', 'Tilbudskatalog'), { resourceActions: [{ resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Offer }] }],
]);

export function applyCatalogCorrections(entries: OmnibarEntry[]): OmnibarEntry[] {
  return entries
    .filter(entry => !removedEntries.has(key(entry.id, entry.label)))
    .map(entry => {
      const correction = corrections.get(key(entry.id, entry.label));
      return correction ? { ...entry, ...correction } : entry;
    });
}
